export default theme => ({
    
    div: {
        backgroundColor: 'white',
        border: '2px solid #000',
        width: '75vw',
        [theme.breakpoints.up('xs')]: {
            width: '75vw',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
        },
    },
    gridContainerObjective:{
        borderColor: '#ff0000',
        borderTopLeftRadius: 1,
        borderStyle:'solid',
        borderRadius: '10px',
        background:'#ffffff'

    },
    objectiveName:{
        textAlign:"center",
        fontWeight: 450,
        fontSize:"21px",
        color:"rgb(255, 255, 255)",
        fontFamily:"Roboto", paddingLeft:"24px"
    },
    grid:{
        paddingBottom:"5%"
    },
    icon:{
        textAlign:"center", 
        color:"rgb(255, 255, 255)",
        paddingBottom:"5%"
    },
    updateTime:{
        fontWeight: 500,
        /* width: '200px' */
      },
      rounded: {
        color: '#fff',
        backgroundColor: '#FF7E00',
        height: '30px'
      },
    
});
